import { type PrimitiveAtom, useSetAtom } from 'jotai'
import React from 'react'

export const useTurnOffAtom = (atom: PrimitiveAtom<boolean>) => {
  const setAtom = useSetAtom(atom)

  return React.useCallback(() => setAtom(false), [setAtom])
}
